import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ---------------addDesignationSchema-------------
export const addDesignationSchema = Yup.object()
  .shape({
    name: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.name)),
    desc: Yup.string(),
  })
  .required();
